export default __webpack_public_path__ + "static/transforming-printing-with-enterprise-platform-8dc60ba4103b8fd0b757c4d81df04248.jpg";